<template>
  <div class="container">
    <h2 class="my-4">Elenco Morosi</h2>
    
    <div v-if="loading" class="loading">Caricamento in corso...</div>
    <div v-else-if="error" class="error">{{ error }}</div>
    <div v-else>
      <div class="row mb-4">
    <div class="col-md-4">
      <label for="corso-filter" class="form-label fw-bold">Filtra per Corso</label>
      <select id="corso-filter" class="custom-select" v-model="selectedCorso">
        <option value="">Tutti i Corsi</option>
        <option v-for="corso in corsiUnici" :key="corso" :value="corso">{{ corso }}</option>
      </select>
    </div>
  </div>
      
      <table class="table table-striped table-hover">
        <thead class="thead-dark">
          <tr>
            <th>Atleta</th>
            <th>Corso</th>
            <th>Debito Totale</th>
            <th>Ultimo Pagamento</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in filteredMorosiData" :key="index">
            <td><Button @click="goToAtleta(item.id_atleta)" class="p-button-link">{{ capitalize(item.cognome) }} {{ capitalize(item.nome) }}</Button></td>
            <td>{{ item.nomeCorso || 'N/D' }}</td>
            <td>€ {{ item.totale_importo.toFixed(2) }}</td>
            <td :class="{'text-danger': !item.lastpay}">
              {{ item.lastpay ? new Date(item.lastpay).toLocaleDateString('it-IT') : 'Nessun pagamento' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {ref,onMounted, getCurrentInstance,computed } from 'vue';
import Service from '@/services/levante-api/levante-api'
import Loader from "@/components/Loader.vue";
import { useToast } from 'primevue/usetoast';
export default {
    components(){
        return [
            Loader
        ]
    },
    data() {
        return {
            showModal: false,
            selectedTransaction: null,
            selectedAtleta: '',
        };
    },
    methods: {
       
     
      
        formattedLastPay(date) {
          if (!date) return '<font style="color:red">Nessun pagamento</font>';
          return new Date(date).toLocaleDateString('it-IT');
        }
    },
    setup(){
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        const service = new Service(self.$eventBus);
        const toast = useToast();
        const morosiData = ref([]);
        const atleti = ref({})

        const loading = ref(false)
        const lifeTime = 3000;
      
        // Nuova ref per il filtro
        const selectedCorso = ref('');

        // Proprietà calcolata per ottenere i corsi unici
        const corsiUnici = computed(() => {
          const corsi = morosiData.value.map(item => item.nomeCorso ? String(item.nomeCorso).trim() : '').filter(Boolean);
          return [...new Set(corsi)].sort();
        });

        // Proprietà calcolata per filtrare i dati
        const filteredMorosiData = computed(() => {
          if (!selectedCorso.value) {
            return morosiData.value;
          }
          return morosiData.value.filter(item => {
             const corso = item.nomeCorso ? String(item.nomeCorso).trim() : '';
             return corso === selectedCorso.value;
          });
        });
  
        const goToAtleta = (idatleta)=> {
          console.log(idatleta)
          window.open(`/atleta/${idatleta}/dettagli`, '_blank')
        }
        const fetchData = async() => {
            const response = await service.getMorosi();
            console.log(response);
            morosiData.value = response.items;

        };
        const capitalize = (str) => {
          if (!str) return '';
          return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        };
       
        onMounted(() => { 
            loading.value = true
            const promises = [fetchData()]
            
            Promise.all(promises)
            .finally(()=>{
                loading.value = false
            })
        })
        return {
            loading,
              morosiData, // Potrebbe non servire più nel template, ma è utile per debug
        filteredMorosiData, // Usa questo nel v-for della tabella
        goToAtleta,capitalize,
        selectedCorso, // Restituisci la ref
        corsiUnici // Restituisci la proprietà calcolata
        };
    },
   
}
</script>

<style scoped>
.modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 1em;
    border: 1px solid #ccc;
}

.confirm-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  z-index: 1000;
}

.confirm-dialog-content {
  text-align: center;
}

.confirm-dialog-content h3 {
  margin-top: 0;
}

.confirm-dialog-content button {
  margin: 10px;
}

.custom-select {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.text-danger {
  color: red;
}

.custom-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
</style>
